import { Button } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { routes } from "config/routeConfig";
import { useModal, useNavigation, useUser, useError } from "common/hooks";
import SignOutConfirmModal from "../Modals/SignOutConfirmModal";
import ImageContainer from "../Containers/ImageContainer";
import KPCLogo from "assets/imgs/kpc-logo.png";
import usePreMutation from "common/hooks/usePreMutation";
import MenuIcon from "assets/imgs/menu_icon.svg";

const SignButton = () => {
  const { isSignedIn } = useUser();
  const { navigate } = useNavigation();
  const { modal } = useModal();
  const { pathname } = useLocation();

  if (isSignedIn) {
    return (
      <Button
        className="header-button"
        variant="text"
        onClick={() => modal.open(<SignOutConfirmModal />)}
      >
        로그아웃
      </Button>
    );
  } else {
    return (
      <Button
        className="header-button"
        variant="text"
        onClick={() =>
          navigate("/sign-in", {
            state: {
              callbackURL: pathname,
            },
          })
        }
      >
        로그인
      </Button>
    );
  }
};

const Header = () => {
  const { navigate } = useNavigation();
  const location = useLocation();
  const [isHeaderNeeded, setIsHeaderNeeded] = useState(true);
  const { isError } = useError();
  const { isSignedIn, user } = useUser();
  const { preMutation } = usePreMutation();

  useEffect(() => {
    routes.forEach((route) => {
      if (location.pathname === route.path) {
        setIsHeaderNeeded(route.requireHeader);
      }
    });
  }, [location]);

  const handleLogoButtonClick = useCallback(async () => {
    await preMutation();
    navigate("/");
  }, []);

  // 메뉴 열고/닫기
  const [openMenu, setOpenMenu] = useState(false);
  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };
  console.log(openMenu);

  return isHeaderNeeded && !isError ? (
    <div className="header-wrapper">
      <div className="header-container">
        <ImageContainer
          src={KPCLogo}
          height={60}
          width={187}
          className="header-logo"
          onClick={handleLogoButtonClick}
        />

        {isSignedIn && (
          <Button
            variant="text"
            className="header-button"
            onClick={handleOpenMenu}
          >
            <div className="user-name-text">
              {user.userName ? `${user.userName}` : ""}
            </div>
            {/* 매뉴 */}
            <div className="header-menu-warp">
              <img
                className="menu-btn"
                src={MenuIcon}
                alt="메뉴"
                onClick={handleOpenMenu}
              />
              <div className={`menu-item-list ${openMenu ? "open" : "close"}`}>
                <div className="menu-item-user">
                  {user.userName ? `${user.userName}` : ""}
                </div>
                <div className="menu-item-btn-list">
                  <Button
                    className="header-button"
                    variant="text"
                    onClick={() => navigate("/my-page")}
                  >
                    비밀번호 변경
                  </Button>
                  <SignButton />
                </div>
              </div>
            </div>
          </Button>
        )}
      </div>
    </div>
  ) : null;
};

export default Header;
